import React from "react";
import styled, { css } from "styled-components";

type OutlinedButtonStyleProps = React.HTMLProps<HTMLButtonElement> & {
  width: string;
  color: string;
};

export const OutlinedButtonStyle = styled.button<OutlinedButtonStyleProps>`
  border: none;
  cursor: pointer;
  border-radius: 5px;
  height: 50px;
  font-size: 0.9375rem;
  font-family: "Mangueira bold";
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    flex: 1;
    justify-self: center;

    i {
      font-size: 20px;
    }
  }

  i {
    font-size: 20px;
  }

  transition: 0.5s background-color, 0.5s border-color, 0.5s color;
  border: 2px solid
    ${(props) => (props.color ? props.color : props.theme.colors.lightBlue)};
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.lightBlue};
  background-color: #fff;

  &:hover {
    opacity: 1;
    background-color: ${(props) =>
      props.color ? props.color : props.theme.colors.lightBlue};
    color: #fff;
  }

  &:hover:disabled {
    opacity: 1;
    background-color: rgb(128, 132, 149);
    color: #fff;
  }

  &:focus {
    box-shadow: none;
    outline: none !important;
  }

  &:not(:disabled):not(.disabled):active {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
  }

  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${(props) => props.color};
    opacity: 0.85;
    box-shadow: none;
    border-color: ${(props) => props.color};
  }

  &:disabled {
    cursor: no-drop;
    border-color: rgb(128, 132, 149);
    color: rgb(128, 132, 149);
  }
`;

export const TrailingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  right: 0;
`;

export const LeadingIconContainer = styled.div`
  position: absolute;
  margin: 0 10px 0 10px;
  left: 0;
`;
